import {t, Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {AutolinkerEditorStateActions} from '../../../editors/autolinkerEditor/useAutolinkerEditorState';

/*
 * Props.
 */

interface AutolinkerDescriptionInputProps {
  description?: string;
  onUpdate: AutolinkerEditorStateActions['onUpdateDescription'];
  isReadOnly: boolean;
}

/*
 * Component.
 */

// @TODO: Probably move this to editors common inputs.

export const AutolinkerDescriptionInput: FC<AutolinkerDescriptionInputProps> = (props) => {
  const {description, onUpdate, isReadOnly} = props;
  const localize = useLocalize();

  return (
    <TextBox
      value={description}
      onChange={onUpdate}
      size={VisualSizesEnum.LARGE}
      noMargin
      label={<Trans id="autolinker-editor-description-label">Description</Trans>}
      placeholder={localize(t('autolinker-editor-description-placeholder')`Which content will be referenced`)}
      isDisabled={isReadOnly}
      shouldAutoFocus
    />
  );
};
